import {Component, Input} from '@angular/core';
import {NgClass} from "@angular/common";

@Component({
  selector: 'form-item',
  standalone: true,
    imports: [
        NgClass
    ],
  templateUrl: './form-item.component.html',
  styleUrl: './form-item.component.scss'
})
export class FormItemComponent {
    @Input() flexEnd: boolean = false;
    @Input() heightAuto: boolean = false;
}
